import React from 'react';
import { ModalWrapper } from '../../../components/ModalWrapper';
import { LessonSelect } from '../../../components/selects/LessonSelect';
import { SelectLayout } from '../../../components/selects/SelectLayout';
import { Loading } from '../../../components/common/Loading';
import { EditorRow } from '../../../components/common/styles';
import styled from 'styled-components';
import WizardCreateSegments from './wizards/WizardCreateSegments';

type IProps = {
  title: string;
  courseId: number;
  onClose: () => void;
};

enum IWizard {
  CREATE_SEGMENT,
}

type IWizardSelect = { label: string; value: number };

const WIZARD_DATA: { [key in IWizard]: IWizardSelect } = {
  [IWizard.CREATE_SEGMENT]: {
    label: 'CREATE empty SEGMENTS',
    value: IWizard.CREATE_SEGMENT,
  },
};

const LessonOutlineWizardModal: React.FC<IProps> = (props) => {
  const [startPos, setStartPos] = React.useState(0);
  const [endPos, setEndPos] = React.useState(0);
  const [doing, setDoing] = React.useState(false);
  const [wizard, setWizard] = React.useState<IWizard | null>(null);

  const handleChangeStarPos = (id: number, lessonPos: number) => {
    setStartPos(lessonPos);
  };

  const handleChangeEndPos = (id: number, lessonPos: number) => {
    setEndPos(lessonPos);
  };

  const handleChangeWizard = (data: IWizardSelect) => {
    setWizard(data.value);
  };

  const handleDoing = () => {
    setDoing(true);
  };

  const handleDone = () => {
    setDoing(false);
    props.onClose();
  };

  const renderWizard = () => {
    switch (wizard) {
      case IWizard.CREATE_SEGMENT:
        return (
          <WizardCreateSegments
            courseId={props.courseId}
            startPos={startPos}
            endPos={endPos}
            onDoing={handleDoing}
            onDone={handleDone}
          />
        );
      default:
        return null;
    }
  };

  return (
    <ModalWrapper title={'Wizard'} onClose={props.onClose} width={500} height={400}>
      <div>
        <EditorRowStyled>
          <LessonSelect label={'From Lesson'} handleLessonChanged={handleChangeStarPos} />
        </EditorRowStyled>
        <EditorRowStyled>
          <LessonSelect label={'To Lesson'} handleLessonChanged={handleChangeEndPos} />
        </EditorRowStyled>
        <EditorRowStyled>
          <SelectLayout
            data={Object.values(WIZARD_DATA)}
            onChange={handleChangeWizard}
            label={'Action'}
            optionLabelKey="label"
            currentValue={wizard}
          />
        </EditorRowStyled>
        {renderWizard()}
      </div>
      {doing && <Loading />}
    </ModalWrapper>
  );
};

export default LessonOutlineWizardModal;

export const EditorRowStyled = styled(EditorRow)`
  margin-top: 15px;
  margin-bottom: 15px;
`;
